<section class="lp-countries-hero-jumbotron">
  <div class="row">
    <div class="col-12">
      <div class="lp-countries-hero-wrapper">
        <div class="lp-countries-hero-left">
          <h1>
            Buy from
            <span class="highlight" *ngIf="fromCountryDetail.country_code === 'US' || fromCountryDetail.country_code === 'UK'" >the {{fromCountryDetail.country_code}}</span> 
            <span class="highlight" *ngIf="fromCountryDetail.country_code !== 'US' && fromCountryDetail.country_code !== 'UK'" >{{fromCountryDetail.country_name}}</span>, Ship to <span *ngIf="activeCountry.country_code == 'AE' || activeCountry.country_code == 'UK' || activeCountry.country_code == 'US' || activeCountry.country_code == 'NL'">the</span>

            <div class="lp-countries-hero-select-dropdown" [ngClass]="activeCountry.country_code == 'AE' || activeCountry.country_code == 'UK' || activeCountry.country_code == 'US' || activeCountry.country_code == 'NL' || activeCountry.country_code == 'DO' || activeCountry.country_code == 'CZ'  ? 'lcn' : ''">
              <div class="lp-countries-hero-select-dropdown-input" (click)="showCountrySelection = !showCountrySelection">
                <div class="lp-countries-hero-select-dropdown-input-flag">
                  <img
                    src="{{activeCountry.country_flag}}"
                    alt="{{activeCountry.country_name}}"
                  />
                </div>
                <div class="lp-countries-hero-select-dropdown-input-country">
                  <strong *ngIf="activeCountry.country_code !== 'US'">{{activeCountry.country_name}}</strong>
                  <strong *ngIf="activeCountry.country_code === 'US'">United States</strong>
                </div>
                <div class="lp-countries-hero-select-dropdown-input-control">
                  <button
                  aria-label="Select Country"
                    class="lp-countries-hero-select-dropdown-input-control-btn"
                    [ngClass]="
                      showCountrySelection ? 'rotate-180deg' : 'rotate-to-0'
                    "
                  >
                    <img
                      src="assets/img/lp-countries/icons/arrow-right.png"
                      alt="{{activeCountry.country_name}}"
                    />
                  </button>
                </div>
              </div>

              <div
                class="lp-countries-hero-select-dropdown-selection"
                [ngClass]="showCountrySelection ? 'show-selection' : 'hide-selection'">
                <div class="lp-countries-hero-select-dropdown-selection-list" (click)="showCountrySelection = !showCountrySelection">
                  <div *ngFor="let country of countriesList; let last=last" (click)="setActiveCountry(country)">
                    <div *ngIf="country.country_code !== fromCountryDetail.country_code" class="lp-countries-hero-select-dropdown-selection-list-item" [ngClass]="!last ? 'selection-list-item-border' : ''">
                      <img src="{{country.country_flag}}" alt="{{country.country_name}} flag"/>
                      {{country.country_name}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            with Shippn.
          </h1>

          <h3>
            Saving money is the <span class="highlight">1st</span> reason why
            customers in <span id="selected-country"><span *ngIf="activeCountry.country_code === 'UK' || activeCountry.country_code === 'US'">the </span>{{activeCountry.country_name}}</span> use Shippn.
          </h3>

          <div class="lp-countries-hero-cta-wrapper">
            <button class="lp-countries-hero-cta-btn" [routerLink]="['/','signup']" aria-label="Sign Up For Free">
              Sign Up For Free
            </button>
            <button class="lp-countries-hero-cta-btn video-btn" (click)="openYTVideoDialog()" aria-label="See The Video">
             <span>&#9654;</span>  See The Video
            </button>
          </div>
        </div>
        <div class="lp-countries-hero-right">
          <img [src]="fromCountryDetail.country_banner" alt="How to shop from United States Of America Banner" />
        </div>
      </div>
    </div>
  </div>
</section>